import { render, staticRenderFns } from "./history-trajectory.vue?vue&type=template&id=23662ca7&scoped=true"
import script from "./history-trajectory.vue?vue&type=script&lang=js"
export * from "./history-trajectory.vue?vue&type=script&lang=js"
import style0 from "./history-trajectory.vue?vue&type=style&index=0&id=23662ca7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23662ca7",
  null
  
)

export default component.exports